<template>
  <div class="progress-setting">
    <div class="field">
      <div class="label">字段</div>
      <div class="value">
        <normal-select
          :select-list="progressControlList"
          :selected-item.sync="progress.stepCid"
          @handle-select="progressSelect"
        ></normal-select>
      </div>
    </div>
    <div class="description" v-if="progress.stepCid">
      <div class="label">描述</div>
      <div class="value">
        <div v-for="(item, index) in stepList" :key="index" class="description-item">
          <el-input disabled :value="item.label" class="option"></el-input>
          <el-input
            v-model="descriptionList[index]"
            @input="output"
            placeholder="请输入"
          ></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NormalSelect from "@/components/UIComponents/NormalSelect"
export default {
  name: "progress-setting",
  components: { NormalSelect },
  data() {
    return {
      stepList: [],
      descriptionList: []
    }
  },
  props: {
    progress: Object,
    sheet: Object
  },
  computed: {
    progressControlList() {
      return this.sheet.data.controls
        .filter(control => control._type === "option" && control.oneFlag)
        .map(control => ({
          label: control.name,
          value: control._cid
        }))
    },
    stepValueList() {
      return this.progress.stepList.map(step => step.value)
    }
  },
  watch: {
    "progress.stepCid": {
      handler() {
        if (this.progress.stepCid) {
          let control = this.sheet.data.controls.find(
            control => control._cid === this.progress.stepCid
          )
          this.stepList = control?.options
        }
      },
      immediate: true
    }
  },
  methods: {
    // 初始化
    init() {
      let result = []
      this.stepList?.forEach(step => {
        if (this.stepValueList.includes(step.value)) {
          let pStep = this.progress.stepList.find(progressStep => progressStep.value === step.value)
          result.push(pStep.description)
        } else {
          result.push("")
        }
      })
      this.descriptionList = result
    },
    progressSelect(val) {
      this.progress.stepCid = val.value
      this.$nextTick(() => this.output())
    },
    // 输出步骤条信息
    output() {
      let result = {}
      result.stepCid = this.progress.stepCid
      result.stepList = this.stepList.map((step, index) => {
        step.description = this.descriptionList[index]
        return step
      })
      this.$emit("update", {
        dataType: "progress",
        data: result
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-setting {
  overflow: hidden;
  margin-top: 14px;
  font-size: 14px;
  height: 100%;
  .field {
    display: flex;
    align-items: center;
    .value {
      flex: 1;
      margin-left: 10px;
    }
  }
  .description {
    margin-top: 15px;
    .value {
      margin-top: 10px;
      .description-item {
        display: flex;
        margin-bottom: 15px;
        .option {
          margin-right: 10px;
          width: 140px;
        }
      }
    }
  }
}
</style>
